import { ErrorBoundary } from '@sentry/react';
import { useState } from 'react';

import { NetworkErrorFallback } from '../ErrorFallbacks/NetworkErrorFallback';
import { PrimitiveErrorFallback } from '../ErrorFallbacks/PrimitiveErrorFallback';

import { isChunkLoadError } from './utils';

const NullComponent = () => null;

interface Props {
  children?: React.ReactNode;
}

export const AppPageErrorBoundary: React.FC<Props> = (props) => {
  const [error, setError] = useState<unknown>();
  const FallbackComponent = isChunkLoadError(error) ? NetworkErrorFallback : PrimitiveErrorFallback;

  return (
    <ErrorBoundary
      fallback={(props) => (error ? <FallbackComponent {...props} /> : <NullComponent />)}
      onError={(error) => setError(error)}
      onReset={() => setError(undefined)}
    >
      {props.children}
    </ErrorBoundary>
  );
};
